import { useTranslate } from 'react-polyglot';

import type {
  QuestionAnalyticsCard,
  QuestionAnalyticsCardKey,
} from '../../../../../../utils/buildQuestionAnalytics';
import { Card, ExpandedValue, Grid, Label, Value } from './QuestionCards.styled';

// Written out in full on purpose: building them by interpolating the card name would hide
// them from the translation tooling.
const LABEL_KEYS: Record<QuestionAnalyticsCardKey, string> = {
  responses: '__new.play.analyticsResults.question.card.responses',
  votes: '__new.play.analyticsResults.question.card.votes',
  participation: '__new.play.analyticsResults.question.card.participation',
  hitRate: '__new.play.analyticsResults.question.card.hitRate',
  errorRate: '__new.play.analyticsResults.question.card.errorRate',
  average: '__new.play.analyticsResults.question.card.average',
  topValue: '__new.play.analyticsResults.question.card.topValue',
};

interface QuestionCardsProps {
  cards: QuestionAnalyticsCard[];
  /** Full screen gives the cards a column of their own, so they stack instead of pairing. */
  isExpanded?: boolean;
}

export const QuestionCards = ({ cards, isExpanded = false }: QuestionCardsProps) => {
  const t = useTranslate();

  const ValueText = isExpanded ? ExpandedValue : Value;

  return (
    <Grid $isExpanded={isExpanded}>
      {cards.map(({ key, value }) => (
        <Card key={key}>
          {/* Value and label are separate nodes, so the figures are readable from a test
              instead of being buried inside an interpolated sentence. */}
          <ValueText>{value}</ValueText>
          <Label>{t(LABEL_KEYS[key])}</Label>
        </Card>
      ))}
    </Grid>
  );
};
